import React, { useState, useEffect } from 'react';

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.querySelector('#services');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      title: "Business Strategy",
      description: "Comprehensive strategic planning to align your business goals with market opportunities and drive sustainable growth.",
      features: ["Strategic Planning", "Market Analysis", "Competitive Positioning", "Growth Strategies"]
    },
    {
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
        </svg>
      ),
      title: "Financial Advisory",
      description: "Expert financial guidance to optimize your capital structure, improve cash flow, and maximize profitability.",
      features: ["Financial Planning", "Cash Flow Management", "Investment Analysis", "Risk Assessment"]
    },
    {
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      title: "Operations Optimization",
      description: "Streamline your business processes to improve efficiency, reduce costs, and enhance operational performance.",
      features: ["Process Improvement", "Cost Reduction", "Efficiency Analysis", "Performance Metrics"]
    },
    {
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      title: "Risk Management",
      description: "Comprehensive risk assessment and mitigation strategies to protect your business from potential threats.",
      features: ["Risk Assessment", "Compliance Management", "Insurance Planning", "Crisis Management"]
    },
    {
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      title: "Leadership Development",
      description: "Develop strong leadership capabilities within your organization to drive performance and innovation.",
      features: ["Executive Coaching", "Team Building", "Leadership Training", "Performance Management"]
    },
    {
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      ),
      title: "Performance Analytics",
      description: "Data-driven insights and analytics to measure performance and identify opportunities for improvement.",
      features: ["KPI Development", "Performance Tracking", "Data Analysis", "Reporting Systems"]
    }
  ];

  return (
    <section id="services" className="section-padding-gc bg-transparent relative border-b border-slate-800/80">
      <div className="container-max relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span
            className={`text-champagne-500 text-sm font-semibold tracking-[0.2em] uppercase mb-4 block transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
          >
            What We Offer
          </span>
          <h2
            className={`text-3xl md:text-4xl lg:text-5xl font-bold font-display gradient-text-white mb-6 transition-all duration-1000 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
          >
            Our Services
          </h2>
          <p
            className={`text-lg text-midnight-200 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
          >
            We offer comprehensive consulting services designed to address every aspect of your business needs,
            from strategic planning to operational excellence.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`glass-card p-7 group ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
              style={{
                transitionDelay: `${index * 100}ms`,
                transition: 'all 0.6s ease-out',
              }}
            >
              {/* Icon */}
              <div className="mb-5">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center text-champagne-400 transition-all duration-300 group-hover:scale-110"
                  style={{
                    background: 'rgba(201, 169, 110, 0.1)',
                    border: '1px solid rgba(201, 169, 110, 0.2)',
                  }}
                >
                  {service.icon}
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold font-display text-white mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-midnight-200 mb-5 leading-relaxed text-sm">
                {service.description}
              </p>

              {/* Features */}
              <ul className="space-y-2.5">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-midnight-300">
                    <div
                      className="w-1.5 h-1.5 rounded-full mr-3 flex-shrink-0"
                      style={{ background: 'linear-gradient(135deg, #c9a96e, #e8d5a3)' }}
                    ></div>
                    {feature}
                  </li>
                ))}
              </ul>

              {/* Learn More */}
              <button className="mt-6 text-champagne-400 hover:text-champagne-300 font-medium transition-all duration-300 text-sm flex items-center group/btn">
                Learn More
                <svg className="w-4 h-4 ml-1 transition-transform duration-300 group-hover/btn:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div
          className={`mt-20 text-center rounded-2xl p-10 md:p-14 relative overflow-hidden transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          style={{
            background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.12), rgba(26, 35, 64, 0.8))',
            border: '1px solid rgba(201, 169, 110, 0.2)',
          }}
        >
          {/* Decorative orb */}
          <div
            className="absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20"
            style={{ background: 'radial-gradient(circle, rgba(201,169,110,0.4), transparent)' }}
          ></div>

          <h3 className="text-2xl md:text-3xl font-bold font-display gradient-text-white mb-4 relative z-10">
            Ready to Transform Your Business?
          </h3>
          <p className="text-lg mb-8 text-midnight-200 max-w-2xl mx-auto relative z-10">
            Let's discuss how our consulting services can help you achieve your business goals.
          </p>
          <button
            onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
            className="btn-primary px-10 py-4 text-lg font-display relative z-10"
          >
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
